import { Box, CircularProgress, Typography } from '@mui/material';
import { observer } from 'mobx-react-lite';
import React, { ReactNode } from 'react';
import BTDialog from '../../common/components/BTDialog';
import { baseStore } from '../../store/BaseStore';
import { dialogStore } from '../../store/DialogStore';

interface BaseLayoutProps {
    children: ReactNode;  // AdminBody 또는 다른 컴포넌트를 children으로 받음
}

const BaseLayout: React.FC<BaseLayoutProps> = observer(({ children }) => {
    return (
        <div style={{ width: '100%', height: '100vh' }}>
            <div style={{ width: '100%', height: '100vh' }}>
                {children}
            </div>
            <BTDialog
                open={dialogStore.isShowDialog}
                onClose={() => dialogStore.close()}
                title={dialogStore.title}
                message={dialogStore.message}
                confirmButtonTitle={dialogStore.confirmButtonTitle}
                cancelButtonTitle={dialogStore.cancelButtonTitle}
                icon={dialogStore.icon}
                onConfirm={dialogStore.onConfirm != undefined ? dialogStore.confirm : undefined}
                onCancel={dialogStore.onCancel != undefined ? dialogStore.cancel : undefined}
                isCaution={dialogStore.isCaution}
            />
            {baseStore.isLoading && (
                <Box
                    position="fixed"
                    top={0}
                    left={0}
                    width="100vw"
                    height="100vh"
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    justifyContent="center"
                    zIndex={1300} // MUI 기본 Dialog보다 위로
                    bgcolor="rgba(0, 0, 0, 0.6)" // 반투명 배경 (선택)
                >
                    <CircularProgress color="primary" />
                    <Typography sx={{ marginTop: '12px', color: 'white', opacity: 0.5 }}>잠시만 기다려주세요...</Typography>
                </Box>
            )}
        </div>
    );
});

export default BaseLayout;
